import { lazy, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { pageNames } from '@common/routes/pageNames';
import { useOfferFilters } from '@libs/creditkit';

const Offers = lazy(() => import('@hub/pages/Offers'));
const Details = lazy(() => import('@hub/pages/Details'));
const FullFunnelRedirect = lazy(() => import('@hub/pages/FullFunnelRedirect'));

const LoansFallback = () => {
  const { goToOffersPage } = useOfferFilters();
  useEffect(() => {
    goToOffersPage({ path: pageNames.offers.path, category: 'loans' });
  }, []);
  return <></>;
};

export function Router() {
  return (
    <>
      <Route path={pageNames.offers.path} element={<Offers />} />
      <Route path={pageNames.loans.path} element={<LoansFallback />} />
      <Route path={pageNames.details.path} element={<Details />} />
      <Route path={pageNames.offerAnalysis.path} element={<FullFunnelRedirect />} />
    </>
  );
}
